(function () {
  function init(root) {
    var dataEl = root.querySelector('[data-mf-data]');
    var i18n = {};
    try { i18n = JSON.parse(root.getAttribute('data-i18n') || '{}'); } catch (e) {}
    var raw = { products: [] };
    try { raw = JSON.parse(dataEl.textContent); } catch (e) {}
    var products = raw.products || [];

    var heightSel = root.querySelector('[data-mf-height]');
    var diameterSel = root.querySelector('[data-mf-diameter]');
    var submitBtn = root.querySelector('[data-mf-submit]');
    var resultsWrap = root.querySelector('[data-mf-results]');
    var grid = root.querySelector('[data-mf-grid]');
    var empty = root.querySelector('[data-mf-empty]');

    function updateSubmit() {
      if (submitBtn) submitBtn.disabled = !(heightSel.value && diameterSel.value);
    }

    function render() {
      var h = heightSel.value;
      var d = diameterSel.value;
      if (!h || !d) { resultsWrap.hidden = true; return; }
      var matches = products.filter(function (p) {
        return (!h || p.height === h) && (!d || p.diameter === d);
      });

      while (grid.firstChild) grid.removeChild(grid.firstChild);

      if (matches.length === 0) {
        empty.textContent = i18n.empty || 'Ingen montager matcher.';
        empty.hidden = false;
        grid.hidden = true;
      } else {
        empty.hidden = true;
        grid.hidden = false;
        matches.forEach(function (p) {
          var li = document.createElement('li');
          li.className = 'mf-item';
          var sub = [p.finish, p.material].filter(Boolean).join(' ');
          var priceAttr = (p.priceCents != null) ? ' data-pcty-price-cents="' + p.priceCents + '"' : '';
          li.innerHTML =
            '<a href="' + p.url + '" class="mf-link">' +
              '<div class="mf-media">' +
                (p.image ? '<img src="' + p.image + '" alt="' + (p.imageAlt || p.title).replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
              '</div>' +
              '<div class="mf-body">' +
                '<h4 class="mf-title">' + p.title + '</h4>' +
                (sub ? '<p class="mf-meta">' + sub + '</p>' : '') +
                (p.vendor ? '<p class="mf-meta">' + p.vendor + '</p>' : '') +
                '<p class="mf-price"' + priceAttr + '>' + p.price + '</p>' +
              '</div>' +
            '</a>';
          grid.appendChild(li);
        });
        if (window.PctyCurrency && typeof window.PctyCurrency.convertAll === 'function') {
          window.PctyCurrency.convertAll(grid);
        }
      }
      resultsWrap.hidden = false;
    }

    function onChange() { updateSubmit(); if (!submitBtn) render(); }
    heightSel.addEventListener('change', onChange);
    diameterSel.addEventListener('change', onChange);
    if (submitBtn) submitBtn.addEventListener('click', render);
    updateSubmit();
  }

  function boot() {
    document.querySelectorAll('[data-montage-finder]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
